import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import Axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { dateTimeReportFormatter } from "../fomatters/DateFormatter";

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 120,
  },
}));

export default function InputSelectGameParent({
  idSport,
  disabled,
  setSelectValue,
}) {
  const classes = useStyles();

  const [idGame, setIdGame] = useState(0);
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => setOpen(true), [setOpen]);
  const handleClose = useCallback(() => setOpen(false), [setOpen]);

  const onGameChanged = useCallback(
    (event) => {
      setIdGame(event.target.value);
      setSelectValue(event.target.value);
    },
    [setSelectValue]
  );

  const [games, setGames] = useState([]);
  useEffect(() => {
    setIdGame(0);
    //Change for server api address
    const url =
      process.env.REACT_APP_API2_URL +
      `/Game/Games_GetGameParents?idSport=${idSport}`;
    Axios.get(url)
      .then((response) => response.data)
      .then((data) => setGames(data));
  }, [idSport]);

  return (
    <FormControl
      disabled={disabled}
      className={`${classes.formControl}`}
      size="small"
      variant="outlined"
    >
      <InputLabel shrink id="Game">
        Game
      </InputLabel>
      <Select
        labelId="Game"
        value={idGame}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        onChange={onGameChanged}
      >
        <div className=" flex items-center justify-center px-[16px] py-[6px] gap-4 border-b border-gray-200">
          <span className="w-24 text-left">Date Time</span>
          <span className="w-20 text-center">#</span>
          <span className="flex-1">Team Name</span>
        </div>
        {games &&
          games.map((game) => (
            <MenuItem value={game?.IdGame} key={game?.IdGame}>
              <div className="flex items-center justify-center flex-1 gap-4 text-xxs leading-[10px]">
                <span className="w-24 text-left">
                  {dateTimeReportFormatter(game?.GameDateTime)}
                </span>
                <div className="flex flex-col items-center justify-center w-20">
                  {game?.VisitorNumber ? (
                    <span>{game?.VisitorNumber}</span>
                  ) : null}
                  {game?.HomeNumber ? <span>{game?.HomeNumber}</span> : null}
                </div>
                <div className="flex flex-col justify-center flex-1">
                  <span>{game?.GameDescription}</span>
                  {game?.VisitorTeam ? <span>{game?.VisitorTeam}</span> : null}
                  {game?.HomeTeam && !game?.IdSport.includes("TNT") ? (
                    <span>{game?.HomeTeam}</span>
                  ) : null}
                </div>
              </div>
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
